module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/social/linkedin-d0d9d99d3dd2eb60aa0b24ed4e38f018.svg";